import React, { Component } from "react";
import { NavLink } from "react-router-dom";

class Nav extends Component {
  componentDidMount() {
    // sidebar open close
    let navLinks = document.querySelector(".nav-links");
    let navLinksLi = document.querySelectorAll(".links li a");
    let menuOpenBtn = document.querySelector(".navbar .bx-menu");
    let menuCloseBtn = document.querySelector(".nav-links .bx-x");
    let jsArrow = document.querySelectorAll(".js-arrow");

    const closeSideBar = () => {
      navLinks.style.left = "-100%";
      document.querySelectorAll(".js-sub-menu").forEach(function (subMenu) {
        subMenu.classList.remove("show"); // Hide other sub-menus
      });
      document.querySelectorAll(".js-arrow").forEach(function (subMenu) {
        subMenu.classList.remove("rotated"); // Hide other sub-menus
      });
    };

    menuOpenBtn.onclick = function () {
      navLinks.style.left = "0";
    };

    menuCloseBtn.onclick = function () {
      closeSideBar();
    };

    document.addEventListener("click", function (event) {
      if (
        !navLinks.contains(event.target) &&
        !menuOpenBtn.contains(event.target)
      ) {
        closeSideBar();
      }
    });

    jsArrow.forEach(function (element) {
      element.onclick = function () {
        document.querySelectorAll(".js-sub-menu").forEach(function (subMenu) {
          subMenu.classList.remove("show"); // Hide other sub-menus
        });

        document.querySelectorAll(".js-arrow").forEach(function (subMenu) {
          subMenu.classList.remove("rotated"); // Hide other sub-menus
        });
        this.classList.toggle("rotated");

        let subMenuClosest = this.closest("li").querySelector(".js-sub-menu");

        if (subMenuClosest) {
          subMenuClosest.classList.add("show"); // Use your existing class for showing/hiding
        }
      };
    });

    navLinksLi.forEach(function (e) {
      e.onclick = function () {
        navLinks.style.left = "-100%";
      };
    });
  }

  render() {
    return (
      <nav className="navbar__main">
        <div className="navbar">
          <i className="bx bx-menu">
            <span>Menü</span>
          </i>
          <div className="nav-links">
            <div className="sidebar-logo">
              <i className="bx bx-x"></i>
            </div>
            <ul className="links">
              <li>
                Számlák
                <i className="bx bxs-chevron-down js-arrow arrow"></i>
                <ul className="js-sub-menu sub-menu">
                  <li>
                    <NavLink
                      to="/incomingbill"
                      activeClassName="active"
                      className="incoming"
                    >
                      Bejövő számlák
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/outgoingbill"
                      activeClassName="active"
                      className="outgoing"
                    >
                      Kimenő számlák
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/customer"
                      activeClassName="active"
                      className="customer"
                    >
                      Partnerek
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/project"
                      activeClassName="active"
                      className="project"
                    >
                      Projektek
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/category"
                      activeClassName="active"
                      className="category"
                    >
                      Költségviselők
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to="/bank" activeClassName="active" className="bank">
                  Bank
                </NavLink>
              </li>
              <li>
                Adó
                <i className="bx bxs-chevron-down js-arrow arrow"></i>
                <ul className="js-sub-menu sub-menu">
                  <li>
                    <NavLink to="/vat" activeClassName="active" className="vat">
                      Áfa
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/tax" activeClassName="active" className="tax">
                      Előírások
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/taxtype"
                      activeClassName="active"
                      className="taxtype"
                    >
                      Adónemek
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li>
                Munkavállalók
                <i className="bx bxs-chevron-down js-arrow arrow"></i>
                <ul className="js-sub-menu sub-menu">
                  <li>
                    <NavLink
                      to="/employee"
                      activeClassName="active"
                      className="employee"
                    >
                      Munkavállalók
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/workinghours"
                      activeClassName="active"
                      className="workinghours"
                    >
                      Napi jelenlét
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/salary"
                      activeClassName="active"
                      className="salary"
                    >
                      Fizetések
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/occasionalsalary"
                      activeClassName="active"
                      className="occasionalsalary"
                    >
                      Alkalmi fizetések
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/vacation"
                      activeClassName="active"
                      className="vacation"
                    >
                      Szabadságok
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/restrain"
                      activeClassName="active"
                      className="restrain"
                    >
                      Letiltások
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/dividend"
                      activeClassName="active"
                      className="dividend"
                    >
                      Osztalékok
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li>
                Autók
                <i className="bx bxs-chevron-down js-arrow arrow"></i>
                <ul className="js-sub-menu sub-menu">
                  <li>
                    <NavLink
                      to="/car"
                      activeClassName="active"
                      className="car"
                    >
                      Autók
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/carday"
                      activeClassName="active"
                      className="carday"
                    >
                      Napok
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink
                  to="/bankaccount"
                  activeClassName="active"
                  className="bankaccount"
                >
                  Bankszámlaszámok
                </NavLink>
              </li>
              <li>
                <NavLink to="/cash" activeClassName="active" className="cash">
                  Pénztár
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/balance"
                  activeClassName="active"
                  className="balance"
                >
                  Egyenleg
                </NavLink>
              </li>
              <li>
                <NavLink to="/owing" activeClassName="active" className="owing">
                  Utalandó
                </NavLink>
              </li>
              <li>
                <NavLink to="/link" activeClassName="active" className="link">
                  Linkek
                </NavLink>
              </li>
              <li>
                <NavLink to="/close" activeClassName="active" className="close">
                  Lezárások
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Nav;
